import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFire1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFire1"><Path d="M20 13.9237C20 24.0199 4 24.031 4 13.9237C4 6.33587 12 2 12 2C12 2 20 6.33587 20 13.9237Z" stroke="currentColor"/><Path d="M15.75 17.7118C15.75 22.76 8.25 22.7655 8.25 17.7118C8.25 13.9179 12 11.75 12 11.75C12 11.75 15.75 13.9179 15.75 17.7118Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFire1;
